import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const GroupOverviewNotesItem = _ref => {
  let {
    note,
    removeNote
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", null, note.author), /*#__PURE__*/React.createElement(Row, {
    key: note.id,
    className: "pb-1"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    style: {
      backgroundColor: 'lightBlue'
    },
    className: "mx-3"
  }, /*#__PURE__*/React.createElement("span", null, note.content), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'grey'
    }
  }, note.formatted_created_at)), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    className: "p-1 d-inline-flex rounded-circle",
    onClick: () => removeNote(note.id)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-danger"
  }, "delete")))));
};
export default GroupOverviewNotesItem;